import ServiceCRUD from '../../../../../../services/ServiceExportFLEXCHAT';

class ConversationExportService extends ServiceCRUD {
  constructor() {
    super('relatorio');
  }
}

export default new ConversationExportService();
